module.exports = __webpack_public_path__ + "img/ico-colon-cancer-90-x-90.e2ef6272.svg";